import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../hooks/useAuthContext";
import { projectFirestore } from "../../firebase/config";
import Table from "../../components/Table";

export default function StudentsList() {
  const { user } = useAuthContext();
  const [data, setData] = useState([]);

  useEffect(() => {
    // Fetch the supervisor data first
    projectFirestore.collection('supervisors').doc(user.uid).get().then(doc => {
      if (doc.exists) {
        const supervisorData = doc.data();
        const studentIds = supervisorData.student_ids;

        // Fetch students based on the student_id field
        const studentsRef = projectFirestore.collection('students');
        const promises = studentIds.map(studentId => 
          studentsRef.where('student_id', '==', studentId.toString()).get()
        );

        Promise.all(promises).then(snapshots => {
          const matchingStudents = [];
          snapshots.forEach(snapshot => {
            snapshot.forEach(doc => {
              matchingStudents.push(doc.data());
            });
          });
          setData(matchingStudents);
        });

      } else {
        console.log("No such supervisor!");
      }
    }).catch(error => {
      console.log("Error getting supervisor:", error);
    });
  }, [user.uid]); // Added user.uid as a dependency

  return (
    <div
      className="container"
      style={{
        display: "flex",
        marginTop: "20px",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
       <Table title={"طلبات التسجيل"} data={data}/>
    </div>
  );
}